import fetch from 'isomorphic-fetch';
import {API2_URL, PHASES_REQUEST, PHASES_SHOW, PHASES_LIST, PHASE_EDIT, PHASES_FAIL} from "../store/config";
import { newNotification } from "./notifications";
import { history } from './../store/store';
import _ from 'lodash';
import {sessionService} from "redux-react-session";

/* Phases Show */
export const phasesShow = (page = 1) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(phasesRequest());
				return fetch(`${API2_URL}/phases?include[0]=status&page=${page}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(phasesData(json)),
						error => {
							dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(phasesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

/* Phases Show */
export const phasesList = () => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(phasesRequest());
				return fetch(`${API2_URL}/phases?per_page=all`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(phasesListData(json)),
						error => {
							dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(phasesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

/* Phase Edit */
export const phaseEdit = (id) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(phasesRequest());
				return fetch(`${API2_URL}/phases/${id}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(phasesEditData(json)),
						error => {
							dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(phasesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

/* Phase Save */
export const phaseSave  = (values) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				dispatch(phasesRequest());

				let body = new FormData();

				_.mapKeys(values, (o,j) => {
					if(j === 'documents_items'){
						_.map(values.documents_items, (item, key) => {
							_.mapKeys(item, (d,n) => {
								if(n === 'documents_types'){
									_.map(d, (i,k) => {
										_.mapKeys(i, (t,s) => {
											if(t !== undefined && t !== null) {
												if(!_.isObject(t) &&  !_.startsWith(t, 'http://')){
													body.append(`${j}[${key}][${n}][${k}][${s}]`, t);
												}else if(_.isObject(t) && !_.isEmpty(t) && t[0] !== undefined) {
													body.append(`${j}[${key}][${n}][${k}][${s}]`, t[0]);
												}
											}
										});
									})
								}else {
									if(d !== undefined && d !== null) {
										if(!_.isObject(d) &&  !_.startsWith(d, 'http://')){
											body.append(`${j}[${key}][${n}]`, d);
										}else if(_.isObject(d) && !_.isEmpty(d) && d[0] !== undefined) {
											body.append(`${j}[${key}][${n}]`, d[0]);
										}
									}
								}
							});
						})

					}else {
						if(o !== undefined && o !== null) {
							if(!_.isObject(o) &&  !_.startsWith(o, 'http://')){
								body.append(j, o);
							}else if(_.isObject(o) && !_.isEmpty(o) && o[0] !== undefined) {
								body.append(j, o[0]);
							}
						}
					}

				});

				const options = {headers: {
						'Accept': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: body
				};

				return fetch(`${API2_URL}/phases${values.id ? `/${values.id}?_method=PUT`:''}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title: "Éxito", content: json.message ? json.message: "El Sub-proceso se ha guardado correctamente", type: "success"}));
							if(_.isEmpty(values.id)){
								history.push(`/fases/editar/${json.data.id}`);
							}
							return dispatch(phasesEditData(json))
						},
						error => {
							dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(phasesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

/* Section Delete */
export function phaseDelete(id) {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'DELETE'
				};

				dispatch(phasesRequest());
				return fetch(`${API2_URL}/phases/${id}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title: "Éxito", content: json.message ? json.message:"El Sub-proceso se ha borrado Exitosamente", type: "success"}));
							dispatch(phasesShow())
						},
						error => {
							dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(phasesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
}

/*Request*/
const phasesRequest = () => {
	return {
		type: PHASES_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
};

const phasesData = (json) => {
	return {
		type: PHASES_SHOW,
		isFetching: false,
		payload: json.data,
		pages: {
			current: json.current_page,
			per_page: json.per_page,
			total: json.total
		},
		permissions: json.permissions,
		timestamp: Date.now()
	};
};

const phasesListData = (json) => {
	return {
		type: PHASES_LIST,
		isFetching: false,
		payload: json.data,
		permissions: json.permissions,
		timestamp: Date.now()
	};
};

const phasesEditData = (json) => {
	return {
		type: PHASE_EDIT,
		isFetching: false,
		payload: json.data,
		permissions: json.permissions,
		timestamp: Date.now()
	}
};

/*Fail*/
const phasesFail = (error) => {
	return {
		type: PHASES_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
};




// WEBPACK FOOTER //
// ./src/actions/phases.js